module.exports = __webpack_public_path__ + "img/articles.8031d8db.svg";